import { Component } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { AsyncPipe, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { StButtonComponent } from '~/dash/core/st-button/st-button.component';
import { ToastMessage, ToastService } from '~/core/services/toast.service';
import { UtilsService } from '~/core/helpers/utils';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 0 }),
                animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
            ]),
            transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))]),
        ]),
    ],
    imports: [
    NgClass,
    AsyncPipe,
    MatIconModule,
    FlexModule,
    MatButtonModule,
    MatTooltipModule,
    StButtonComponent,
    TranslateModule,
    FlexLayoutModule
]
})
export class ToastComponent {
  toasts$ = this.toastService.toasts$;
  isDesktop: boolean = false;

  constructor(private toastService: ToastService) {
    this.isDesktop = UtilsService.isDesktop();
  }

  dismissToast(toast: ToastMessage) {
    this.toastService.dismissToast(toast);
  }

  clickToast(toast: ToastMessage) {
    if (toast.click) {
      toast.click();
    }

    this.dismissToast(toast);
  }
}
